import React, { lazy, Suspense } from 'react';

import clientOnly from '../../hoc/clientOnly';

const Root = lazy(() =>
  import(/* webpackChunkName: "SampleRequest" */ './components/Root')
);

const SampleRequest = clientOnly(props => (
  <Suspense fallback={null}>
    <Root {...props} />
  </Suspense>
));

export { SampleRequest };
